import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';


export class ProjectData extends Component {

    render() {
        //const { onChange, onChangetypeOfROM, typeOfROM, projectTitle, projectNumber, status } = this.props;
        const { onChange, projectTitle, projectNumber, status, userType } = this.props;

        var typeOfROMOptions = [
            { TypeId: 1, TypeName: "On Going" },
            { TypeId: 2, TypeName: "Ex-Post" }
        ];

        return (
            <Card>
                <CardHeader title="Project Data" className='romis-card-header' />
                <CardContent>
                    {
                        //<Autocomplete
                        //    options={typeOfROMOptions}
                        //    getOptionLabel={option => option.TypeName}
                        //    autoComplete
                        //    includeInputInList
                        //    onChange={onChangetypeOfROM}
                        //    //name="typeOfROM"
                        //    renderInput={params => (
                        //        <TextField
                        //            {...params}
                        //            label="Type of ROM"
                        //            placeholder="Type of ROM"
                        //            fullWidth
                        //            margin="normal"
                        //        //InputLabelProps={{
                        //        //    shrink: true,
                        //        //}}
                        //        //onChange={onChange}
                        //        //value={typeOfROM}
                        //        //name="typeOfROM"
                        //        />
                        //    )}
                        ///>
                    }
                    <TextField
                        label="Project Number :"
                        placeholder="Project Number"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onChange={onChange}
                        value={projectNumber}
                        name="projectNumber"
                        disabled={userType !== 2 ? true : false}
                    />
                    <TextField
                        label="Project Title :"
                        placeholder="Project Title"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        onChange={onChange}
                        value={projectTitle}
                        name="projectTitle"
                        disabled={userType !== 2 ? true : false}
                        multiline
                    />
                    {
                        //<TextField
                        //    label="Status :"
                        //    placeholder="Status"
                        //    fullWidth
                        //    margin="normal"
                        //    InputLabelProps={{
                        //        shrink: true,
                        //    }}
                        //    onChange={onChange}
                        //    value={status}
                        //    name="status"

                        ///>
                    }
                </CardContent>
            </Card>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ProjectData.js